import type { SxProps, Theme } from '@mui/material';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import { Color } from 'shared/utils/colors';

// Icon size styles
export const iconHeightSx = { height: '16px' };
export const removeIconSx = {
  transform: 'rotateY(0deg) rotate(-45deg)',
  height: '20px',
};

export const errorIconSx = {
  height: '29px',
  width: '29px',
};

// Color constants
export const ComplianceAnswerOptionColor: Record<
  ComplianceAnswerOption,
  string
> = {
  [ComplianceAnswerOption.notPassed]: Color.red,
  [ComplianceAnswerOption.unset]: Color.disabledGray,
  [ComplianceAnswerOption.passed]: Color.statusSuccessGreen,
  [ComplianceAnswerOption.notApplicable]: Color.iconGray,
};

// Base icon styles
export const iconBaseSx: SxProps<Theme> = {
  border: '1px solid',
  borderRadius: '50%',
  width: '24px',
  height: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
};

export const errorIconContainerSx: SxProps<Theme> = {
  width: '32px',
  height: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: Color.red,
  borderColor: 'transparent',
};

// Status-specific styles
export const getIconStatusSx = (
  status: ComplianceAnswerOption
): SxProps<Theme> => ({
  borderColor: ComplianceAnswerOptionColor[status],
  color: ComplianceAnswerOptionColor[status],
});
